/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, computed } from '@angular/core';
import dayjs from 'dayjs';
import { get } from '../../../../../helpers/object-get';
import { DateColumnDefinition } from '../../../types/column.type';
import { CellAdapter } from '../cell-adapter.component';

@Component({
  selector: 'lepi-text-cell',
  template: ` <p [ngClass]="column().style?.cellClass">{{ content() }}</p> `,
  standalone: true,
  imports: [CommonModule],
})
export class TextCell extends CellAdapter {
  /**
   * @description column의 type에 따라 셀 내용을 반환합니다.
   */
  content = computed(() => {
    if (!this.column()) return '-';

    const __value = get(this.row(), this.column().field, '');

    // 빈 값 체크 (null, undefined, 빈문자열)
    if (__value === null || __value === undefined || __value === '') return '-';

    // formatter 처리
    const _value = this.column()?.formatter
      ? this.column().formatter!(__value, this.row())
      : __value;

    // pipe 처리
    const value = this.column()?.pipe
      ? this.column().pipe!.transform(_value)
      : _value;

    switch (this.column().type) {
      case 'text': {
        return value;
      }
      case 'number': {
        return new DecimalPipe('en-US').transform(value);
      }
      case 'date': {
        const column = this.column() as DateColumnDefinition;
        return dayjs(value).format(column.format || 'YYYY-MM-DD');
      }
    }
  });
}
